import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import {
  ChartIcon,
  RepoetIcon1,
  RepoetIcon2,
  RepoetIcon3,
  RepoetIcon4,
  NextRightIcon,
} from '@styled/icon';
import Color from '@/tool/color';
import moUser from '@/store/user';

interface IProps {}
interface IState {}

const CustomReport = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin, reportCount, isReportExpired } = moUser;

  // 定制薪酬报告
  const onJumpCustomreport = () => {
    if (isLogin && reportCount > 0 && !isReportExpired) {
      window.location.href = '/customreport';
    } else {
      window.location.href = '/home/customreport';
    }
  };

  const goDemo = () => {
    window.open('https://file.smartsalary.cn/%E5%AE%9A%E5%88%B6%E6%8A%A5%E5%91%8A-%E6%A0%B7%E6%9C%AC.pdf');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="dash-report-warp">
      <section className="dash-report-content">
        <section className="left">
          <h3>定制薪酬报告</h3>
          <section className="content">
            <section className="items">
              <p>
                <RepoetIcon1 color={Color.white} />
                &nbsp;选
              </p>
              <h4>百万对标企业</h4>
              <span>确保可比性</span>
            </section>
            <NextRightIcon />
            <section className="items">
              <p>
                <RepoetIcon2 color={Color.white} />
                &nbsp;岗
              </p>
              <h4>特有岗位细分</h4>
              <span>涵盖非基准职位</span>
            </section>
            <NextRightIcon />
            <section className="items">
              <p>
                <RepoetIcon3 color={Color.white} />
                &nbsp;评
              </p>
              <h4>岗位价值评估</h4>
              <span>客观评定职级</span>
            </section>
            <NextRightIcon />
            <section className="items">
              <p>
                <RepoetIcon4 color={Color.white} />
                &nbsp;薪
              </p>
              <h4>薪酬报告</h4>
              <span>更具参考性</span>
            </section>
          </section>
        </section>
        <section className="right">
          <a onClick={goDemo}>查看报告样例</a>
          <h4>当前报告数</h4>
          <span>{reportCount || 0}</span>
          <p onClick={onJumpCustomreport}>获取定制薪酬报告</p>
        </section>
      </section>
    </section>
  );
};

export default observer(CustomReport);
